import request from '@/utils/request';

// 获取URL Scheme 链接
export function scheme(params) {
  return request.post('/v1/wechat/applet/getOpenLink', params);
}
